enum Calculation {
    UserDefined,
    Automated,
}

export default Calculation;
